import React from 'react';
import { useHistory } from 'react-router-dom';

import HeaderTopic from './../../partials/HeaderTopic';
import BasicButtons from '../../partials/BasicButtons';
import FooterMenu from '../../partials/FooterMenu';
import Loading from '../Loading/Loading';
import srcWhistle from './../../graphics/images/whistle.png';

import styles from './LeaguesList.module.css';
import { userLeagues } from '../../api/userLeagues';


function LeaguesList(props) {
  const { user, setLeague, refreshStates } = props;
  const [myLeagues, setMyLeagues] = React.useState(null);

  const history = useHistory();

  const isReferee = (user?.refereed_league_ids?.length ?? 0) > 0;

  React.useEffect(() => {
    let mounted = true;

    userLeagues().then(data => {
      if (data.error) {

      } else {
        if (data.length === 1) {
          setLeague(data[0]);
          history.push(`/leagues/${data[0].id}`);
        }
        mounted && setMyLeagues(data);
      }
    });

    return function cleanup() {
      mounted = false;
    };
  }, [history, setLeague]);

  const showMyLeagues = myLeagues?.map(league => (
    <li
      key={league.id}
      onClick={() => {
        handleClick(league);
      }}
    >
      <h2>ליגת {league.name}</h2>
      <h5>
        מתאריך {league.start_date} עד תאריך {league.end_date}
      </h5>
      <h4>יישוב: {league.city_name}</h4>
    </li>
  ));

  const handleClick = league => {
    setLeague(league);
    const leagueId = league.id;
    const url = `leagues/${leagueId}`;
    history.push(url);
  };

  return myLeagues !== null ? (
    <div className={styles.leagueList}>
      <HeaderTopic topic={isReferee ? 'הליגות שלך לשיפוט' : 'הליגות שבריכוזך'} />
      <FooterMenu />
      <BasicButtons user={user} refreshStates={refreshStates} />

      <div className={styles.bgVisual}></div>
      <div className={styles.list}>
        {myLeagues.length > 1 && <ul>{showMyLeagues}</ul>}
        {myLeagues.length === 0 && (
          <div className={styles.noLeaguesContainer}>
            <h2 className={styles.noLeaguesHeader}>
              {isReferee
                ? 'לא שויכת לאף ליגה, פנה/י למנהל/ת המערכת'
                : 'אין לך ליגות שאתה מרכז/ת פנה/י למנהל/ת המערכת'}
            </h2>
            <img src={srcWhistle} alt="שופר" />
          </div>
        )}
      </div>
    </div>
  ) : (
    <Loading />
  );
}



export default LeaguesList;
